import { render, staticRenderFns } from "./saveDialog.vue?vue&type=template&id=58e2abe1&"
import script from "./saveDialog.vue?vue&type=script&lang=ts&"
export * from "./saveDialog.vue?vue&type=script&lang=ts&"
import style0 from "./saveDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports